import 'default-passive-events'
import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import router from './utils/router'
import i18n from './lang'
import '@/icons'
import '@/beforeAfter'
import store from './store'
import App from './App.vue'
import { apiData, stageData, menuData, siteData } from './config'
import { getLocal, getEnv } from '@/utils/globalState'
import { loadStyle } from '@/utils/common'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueBarcode from '@chenfengyuan/vue-barcode'
import VueClipboards from 'vue-clipboard2'
import numkeyboard from './components/vue-numkeyboard'
import './components/vue-numkeyboard/style.css'
// 初始化 產生api
import { initAPI } from '@/utils/api'
import './quasar'
import './styles/index.scss'
const currentStage = getEnv('VUE_APP_STAGE') ? getEnv('VUE_APP_STAGE') : 'develop'
initAPI(apiData, stageData, currentStage)
store.dispatch(`SetAPIData`, apiData)
store.dispatch(`SetStageData`, stageData)
store.dispatch(`SetMenuData`, menuData)
store.dispatch(`SetSiteData`, siteData)
// theme
const theme = getLocal('theme', null, 'default')
loadStyle(`static/theme/theme_${theme}.css`)
Vue.config.productionTip = false
Vue.use(VueCompositionApi)
// qrcode barcode
Vue.component(VueQrcode.name, VueQrcode)
Vue.component(VueBarcode.name, VueBarcode)
Vue.use(VueClipboards)
Vue.use(numkeyboard)

export const startApp = async () => {
  // await initFirebase()
  // if (db === null) console.log('firebase not enable please setup')
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}
